import * as React from "react";
import { Image } from "@project-stories/elements/Image/Image";

export const OffsetImages = ({
  primaryImageUrl,
  secondaryImageUrl,
  fit = "cover",
  ratio = "auto",
  overlay = false,
  overlayOpacity = 0,
  classes = "",
  secondaryTop = 0,
  secondaryLeft = 0
}) => {
  if (!primaryImageUrl && !secondaryImageUrl) return null;

  return (
    <div className={`relative ${classes}`}>
      {/* PRIMARY IMAGE */}
      {primaryImageUrl && (
        <Image
          imageUrl={primaryImageUrl}
          classes={`w-full h-full object-${fit}`}
        />
      )}

      {/* OVERLAY */}
      {overlay && (
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: `rgba(0,0,0,${overlayOpacity})` }}
        />
      )}

      {/* SECONDARY IMAGE (OVERLAP) */}
      {secondaryImageUrl && (
        <div
            className={`absolute ${classes}`}
            style={{ top: `${secondaryTop}%`, left: `${secondaryLeft}%` }}
        >
          <Image
            imageUrl={secondaryImageUrl}
            classes={`w-full h-full object-${fit}`}
          />
        </div>
      )}
    </div>
  );
};